import { forwardRef } from 'react';
import { Input } from 'reactstrap';

export const PhoneInputInput = forwardRef((props, ref) => (
	<Input type="tel" {...props} innerRef={ref} />
));
